import SystemHelper, { SystemConstants } from 'features/System/systemHelper';
import KTImageInput from 'general/components/OtherKeenComponents/FileUpload/KTImageInput';
import KTFormInput, {
  KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTBSDropdown, {
  KTBSDropdownDirections,
} from 'general/components/OtherKeenComponents/KTBSDropdown';
import AppColors from 'general/constants/AppColors';
import AppConfigs from 'general/constants/AppConfigs';
import AppConstants from 'general/constants/AppConstants';
import AppResource from 'general/constants/AppResource';
import miscHelper from 'general/helpers/miscHelper';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

DialogAddStaffView.propTypes = {
  initialRole: PropTypes.string,
  item: PropTypes.object,
  onCancel: PropTypes.func,
  onDone: PropTypes.func,
};

function DialogAddStaffView({ item, onCancel, onDone, initialRole }) {
  // MARK: ---- PROPERTIES ----
  const editMode = !!item;
  const [loading, setLoading] = useState(false);
  const [readyToValidate, setReadyToValidate] = useState(false);
  const [avatarFile, setAvatarFile] = useState(null);
  const [avatar, setAvatar] = useState('');
  const [fullname, setFullname] = useState('');
  const [staffCode, setStaffCode] = useState('');
  const [position, setPosition] = useState('');
  const [permissionGroupId, setPermissionGroupId] = useState('');
  const [selectedPermissionGroup, setSelectedPermissionGroup] = useState(null);
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [hsmAgreementUUID, setHsmAgreementUUID] = useState('');
  const { user } = useSelector((state) => state.auth);
  const adminRole =
    user?.role === AppConstants.userRole.admin || user?.role === AppConstants.userRole.operator;
  const [permissionGroupList, setPermissionGroupList] = useState([]);
  const permissionGroupOptions = useMemo(() => {
    return permissionGroupList.map((item) => ({
      name: item.name,
      value: item.permissionGroupId,
    }));
  }, [permissionGroupList]);
  useEffect(() => {
    let params = {
      role: adminRole ? 'ADMIN' : 'AGENCY',
      subRole: !adminRole ? user?.agency?.primaryRole : '',
    }
    params = _.pickBy(params, (value) => {
      return value !== undefined && value !== null && value !== '';
    });
    SystemHelper.API.Permission.requestGetPermissionGroupList(params).then((res) => {
      setPermissionGroupList(res?.permissionGroups || []);
    });
  }, [adminRole, user]);
  useEffect(() => {
    if (item) {
      setAvatar(item?.avatar);
      setFullname(item?.fullname);
      setEmail(item?.email);
      setPhone(item?.phone);
      setPassword(item?.password);
      setPermissionGroupId(item?.permissionGroupId);
      setStaffCode(item?.userCode);
      setPosition(item?.position);
      setHsmAgreementUUID(item?.hsmAgreementUUID);
    }
  }, [item]);

  // MARK: ---- FUNCTIONS ----

  const handleSubmit = async () => {
    setReadyToValidate(true);
    if (
      !Utils.isValid(fullname) ||
      !Utils.isValid(email) ||
      !Utils.isValid(phone) ||
      !Utils.isValid(permissionGroupId) ||
      (!Utils.isValid(password) && !editMode) ||
      (adminRole && (!Utils.isValid(position)))
    ) {
      ToastHelper.showError('Vui lòng nhập đầy đủ thông tin');
      return;
    }
    if (!phone.match(AppConfigs.regex.phone)) {
      ToastHelper.showError('Số điện thoại không hợp lệ');
      return;
    }
    if (!email.match(AppConfigs.regex.email)) {
      ToastHelper.showError('Email không hợp lệ');
      return;
    }
    if (Utils.isValid(password) && password.length < 6) {
      ToastHelper.showError('Mật khẩu phải có ít nhất 6 ký tự');
      return;
    }
    let params = {
      role: initialRole,
      fullname,
      phone,
      email,
      permissionGroupId,
      password: Utils.isValid(password) ? password : null,
      agencyId: !adminRole ? user?.agency?.agencyId : 1,
      operatorId: 1,
      position,
      hsmAgreementUUID,
    };
    if (avatarFile) {
      const res = await miscHelper.callApiUploadFile(avatarFile);
      if (_.isArray(res) && res.length > 0) {
        params.avatar = res[0].relativePath;
      }
    }
    params = _.pickBy(params, (value) => value !== null && value !== undefined && value !== '');
    // console.log({ params });
    // return;
    setLoading(true);
    if (!editMode) {
      params.status = SystemConstants.UserStatus.NORMAL;
      const res = await SystemHelper.API.User.requestAddUser(params);
      if (_.isBoolean(res) && res) {
        ToastHelper.showSuccess('Thêm mới nhân viên thành công');
        onDone && onDone();
      } else if (_.isString(res)) {
        ToastHelper.showError(res);
      }
    } else {
      const res = await SystemHelper.API.User.requestUpdateUser(item.userId, params);
      if (_.isBoolean(res) && res) {
        ToastHelper.showSuccess('Chỉnh sửa thông tin nhân viên thành công');
        onDone && onDone();
      } else if (_.isString(res)) {
        ToastHelper.showError(res);
      }
    }
    setLoading(false);
  };

  return (
    <div>
      <div className="row m-0 p-0 px-2 mt-4">
        {/* avatar */}
        <div className="col-12 mb-4 px-2">
          {UIHelper.buildFormLabel('Ảnh đại diện')}
          <div className="row m-0 p-0">
            <div className="col-lg-3 col-md-4 col-6 p-0">
              <KTImageInput
                fullWidth={true}
                aspectRatio={'1'}
                name="avatar"
                editable={true}
                value={Utils.isValid(avatar) ? Utils.getFullUrl(avatar) : null}
                acceptImageTypes={['image/png', 'image/jpg', 'image/jpeg']}
                defaultImage={AppResource.icons.avatar.default}
                enableCheckValid
                onSelectedFile={(file) => {
                  setAvatarFile(file);
                  const imageUrl = URL.createObjectURL(file);
                  setAvatar(imageUrl);
                }}
                onRemovedFile={() => {
                  setAvatarFile(null);
                  setAvatar('');
                }}
              />
              {UIHelper.buildFormText('Định dạng: JPG, PNG')}
            </div>
          </div>
        </div>
        {/* fullname */}
        <div className="col-md-6 mb-4 px-2">
          {UIHelper.buildFormLabel('Họ và tên', true)}
          <KTFormInput
            type={KTFormInputType.text}
            placeholder="Nhập họ và tên"
            name="fullname"
            value={fullname}
            onChange={(value) => {
              setFullname(value);
            }}
            enableCheckValid={readyToValidate}
            isValid={Utils.isValid(fullname)}
            isTouched={readyToValidate}
          />
        </div>
        {/* staffCode */}
        <div className="col-md-6 mb-4 px-2">
          {UIHelper.buildFormLabel('Mã nhân viên')}
          <KTFormInput
            type={KTFormInputType.text}
            placeholder="Nhập mã nhân viên"
            name="staffCode"
            value={staffCode}
            onChange={(value) => {
              setStaffCode(value);
            }}
            disabled={true}
          />
        </div>
        {/* email */}
        <div className="col-md-6 mb-4 px-2">
          {UIHelper.buildFormLabel('Email', true)}
          <KTFormInput
            type={KTFormInputType.email}
            placeholder="Nhập email"
            name="email"
            value={email}
            onChange={(value) => {
              setEmail(value);
            }}
            enableCheckValid={readyToValidate}
            isValid={Utils.isValid(email) && email.match(AppConfigs.regex.email)}
            isTouched={readyToValidate}
          />
        </div>
        {/* phone */}
        <div className="col-md-6 mb-4 px-2">
          {UIHelper.buildFormLabel('Số điện thoại', true)}
          <KTFormInput
            type={KTFormInputType.telephone}
            placeholder="Nhập số điện thoại"
            name="phone"
            value={phone}
            onChange={(value) => {
              setPhone(value);
            }}
            enableCheckValid={readyToValidate}
            isValid={Utils.isValid(phone) && phone.match(AppConfigs.regex.phone)}
            isTouched={readyToValidate}
          />
        </div>
        {/* nhom quyen */}
        <div className="col-md-6 mb-4 px-2">
          {UIHelper.buildFormLabel('Nhóm quyền', true)}
          <KTBSDropdown
            name="permissionGroupId"
            direction={KTBSDropdownDirections.up}
            toggleElement={
              <button
                className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${readyToValidate && !Utils.isValid(permissionGroupId) ? 'button-invalid' : ''
                  }`}
                type="button"
              >
                {Utils.isValid(permissionGroupId)
                  ? _.find(
                    permissionGroupList,
                    (item) => item.permissionGroupId === permissionGroupId
                  )?.name
                  : 'Chọn nhóm quyền'}
              </button>
            }
            selectedValue={permissionGroupId}
            dropdownMenuItems={permissionGroupOptions}
            dropdownMenuClassName="overflow-auto w-100"
            dropdownMenuStyle={{ maxHeight: '30vh' }}
            onChange={(value) => {
              setPermissionGroupId(value);
            }}
            isDropdownForm={true}
            searchable
            liveSearch={false}
            onTextChanged={(text) => { }}
          />
        </div>
        {/* password */}
        <div className="col-md-6 mb-4 px-2">
          {UIHelper.buildFormLabel('Mật khẩu', !editMode)}
          <KTFormInput
            type={KTFormInputType.text}
            placeholder="Nhập mật khẩu"
            name="password"
            value={password}
            onChange={(value) => {
              setPassword(value);
            }}
            enableCheckValid={readyToValidate && !editMode}
            isValid={Utils.isValid(password)}
            isTouched={readyToValidate}
          />
        </div>
        {adminRole && (
          <>
            {/* position */}
            <div className="col-md-6 mb-4 px-2">
              {UIHelper.buildFormLabel('Chức vụ', true)}
              <KTBSDropdown
                name="position"
                direction={KTBSDropdownDirections.up}
                toggleElement={
                  <button
                    className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${readyToValidate && !Utils.isValid(permissionGroupId) ? 'button-invalid' : ''
                      }`}
                    type="button"
                  >
                    {Utils.isValid(position)
                      ? _.find(
                        SystemHelper.Data.UserPositionOptions,
                        (item) => item.value === position
                      )?.name
                      : 'Chọn chức vụ'}
                  </button>
                }
                selectedValue={position}
                dropdownMenuItems={SystemHelper.Data.UserPositionOptions}
                dropdownMenuClassName="overflow-auto w-100"
                dropdownMenuStyle={{ maxHeight: '30vh' }}
                onChange={(value) => {
                  setPosition(value);
                }}
                isDropdownForm={true}
                searchable
                liveSearch={false}
              />
            </div>
            {/* hsmAgreementUUID */}
            <div className="col-md-6 mb-4 px-2">
              {UIHelper.buildFormLabel('Số thỏa thuận (Agreement UUID)')}
              <KTFormInput
                type={KTFormInputType.text}
                placeholder="Nhập số thỏa thuận"
                name="hsmAgreementUUID"
                value={hsmAgreementUUID}
                onChange={(value) => {
                  setHsmAgreementUUID(value);
                }}
              />
            </div>
          </>
        )}
      </div>
      {/* actions */}
      <div
        className="d-flex align-items-center justify-content-end gap-3 px-4 py-3"
        style={{
          borderTop: `1px solid ${AppColors.gray[200]}`,
        }}
      >
        {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null)}
        {UIHelper.buildGreenButton(
          !editMode ? 'Thêm nhân viên' : 'Cập nhật',
          handleSubmit,
          null,
          false,
          loading
        )}
      </div>
    </div>
  );
}

export default DialogAddStaffView;
